/* Product Sticky Navigation — 仅处理点击平滑滚动与 active 切换
   不使用任何 Observer API；支持页面多个导航实例与 Theme Editor 重载 */
(function () {
  function initNav(wrapper) {
    if (!wrapper || wrapper.dataset.psnReady === "1") return;
    wrapper.dataset.psnReady = "1";

    var buttons = wrapper.querySelectorAll(".psn-btn");

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        var href = btn.getAttribute("href") || "";
        if (href.charAt(0) !== "#") return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        e.preventDefault();

        // 平滑滚动到锚点（scroll-margin-top 由 CSS 控制偏移）
        target.scrollIntoView({ behavior: "smooth", block: "start" });

        // 切换 active 高亮
        buttons.forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");

        // 更新地址栏 hash，不产生历史记录
        if (window.history && history.replaceState) {
          history.replaceState(null, "", href);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".psn-wrapper").forEach(initNav);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme Editor 兼容：编辑器重新加载 Section 后重新绑定（非 Observer API）
  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target || !e.target.querySelector) return;
    initNav(e.target.querySelector(".psn-wrapper"));
  });
})();
